import { render } from "./question4.vue?vue&type=template&id=b7009cb6&scoped=true"
import script from "./question4.vue?vue&type=script&lang=js"
export * from "./question4.vue?vue&type=script&lang=js"

import "./question4.vue?vue&type=style&index=0&id=b7009cb6&scoped=true&lang=css"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7009cb6"]])

export default __exports__